// Web implementation of the link component.

import { type CSSProperties } from 'react';
import { trackEvent } from 'util/analytics';
import { useDatastore } from 'util/datastore';
import { requestAppNavigateToExternalUrl } from 'util/webview';

import { getIsInPsiNativeAppWebview } from './url';

export type WebLinkBaseProps = {
    url: string;
    children: React.ReactNode;
    setHover?: (h: boolean) => void;
    testID?: string;
    onLinkPress?: () => void;
    style?: CSSProperties;
    linkType?: string;
};

export function WebLinkBase({ url, style, setHover = (h: boolean) => {}, children, onLinkPress, linkType }: WebLinkBaseProps) {
    const datastore = useDatastore();
    const onClick = () => {
        if (linkType) {
            trackEvent(datastore, 'link-click', { linkType, url });
        }

        if (onLinkPress) {
            onLinkPress();
        }

        if (getIsInPsiNativeAppWebview()) {
            requestAppNavigateToExternalUrl(url);
        }
    };

    return (
        <a
            href={url}
            onClick={onClick}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            rel='noreferrer'
            style={style}
            target='_blank'
        >
            {children}
        </a>
    );
}
